import { all, put, call, take, takeLatest, race } from 'redux-saga/effects'

import { log } from './utils'
import * as actions from './actions'
import * as api from './api'
import * as form from 'redux-form'

/**
 * Initialize when application opened or user logged-in
 */
function* handleInit(action) {
  try {
    log(action)

    //// preload list
    //yield put(actions.loadEntries())

    //// Wait until list loaded success
    //const [success, failure] = yield race([
    //  take('MODULE/PROJECT/LOAD_ENTRIES/SUCCESS'),
    //  take('MODULE/PROJECT/LOAD_ENTRIES/FAILURE'),
    //])

    const { active, permissions } = yield call(api.loadActiveAndPermissions)

    yield put(actions.setActive(active))
    yield put(actions.setPermissions(permissions))

    yield put(actions.initSuccess())
  } catch (e) {
    console.error(e)
    yield put(actions.initFailure(e))
  }
}

function* handleSetActive(action) {
  try {
    log(action)

    yield call(api.setActiveProject, action.payload.id)
  } catch (err) {
    console.error(err)
  }
}

/**
 * Load List
 */
function* handleLoadEntries(action) {
  try {
    log(action)

    //
    const entries = yield call(api.loadEntries)

    yield put(
      actions.loadEntriesSuccess(entries ? entries : [], entries.length, 0),
    )
  } catch (e) {
    console.error(e)
    yield put(actions.loadEntriesFailure(e))
  }
}

/**
 * Load
 */
function* handleLoadEntry(action) {
  try {
    log(action)

    //
    const entry = yield call(api.loadEntry, action.payload.id)

    yield put(actions.loadEntrySuccess(entry))
  } catch (e) {
    console.error(e)
    yield put(actions.loadEntryFailure(e))
  }
}

function* handleAddEntry(action) {
  try {
    log(action)

    //
    const entry = yield call(api.registrateEntry, action.payload.data)

    yield put(actions.addEntrySuccess(entry))
  } catch (e) {
    console.error(e)
    yield put(actions.addEntryFailure(e))
  }
}

function* handleUpdateEntry(action) {
  try {
    log(action)

    //
    const entry = yield call(
      api.updateEntry,
      action.payload.data.id,
      action.payload.data,
    )

    yield put(actions.updateEntrySuccess(entry))
  } catch (e) {
    console.error(e)
    yield put(actions.updateEntryFailure(e))
  }
}

function* handleRemoveEntry(action) {
  try {
    log(action)

    //
    const entry = yield call(
      api.deleteEntry,
      action.payload.id,
      action.payload.password,
    )

    yield put(actions.removeEntrySuccess(entry))
  } catch (e) {
    console.error(e)
    yield put(actions.removeEntryFailure(e))
  }
}

function* handleCloneEntry(action) {
  try {
    log(action)

    //
    const entry = yield call(
      api.cloneEntry,
      action.payload.source,
      action.payload.copyBoard,
      action.payload.suffix,
    )

    yield put(actions.cloneEntrySuccess(entry))
  } catch (e) {
    console.error(e)
    yield put(actions.cloneEntryFailure(e))
  }
}

function* handleCreateForm(action) {
  const formName = action.payload.props.form

  try {
    log(action)

    yield put(form.startSubmit(formName))

    const [_, [success, failure]] = yield all([
      put(actions.addEntry(action.payload.data)),
      race([
        take('MODULE/PROJECT/ADD_ENTRY/SUCCESS'),
        take('MODULE/PROJECT/ADD_ENTRY/FAILURE'),
      ]),
    ])

    if (failure) {
      throw failure
    }

    yield put(form.stopSubmit(formName))
    yield put(form.setSubmitSucceeded(formName))

    if (action.payload.props.onSubmitSuccess) {
      action.payload.props.onSubmitSuccess(
        success?.payload?.registratedEntry,
        action.payload.dispatch,
        action.payload.props,
      )
    }
  } catch (err) {
    console.error(err)
    try {
      yield put(
        form.stopSubmit(formName, {
          _error: 'SubmitFailed',
        }),
      )

      yield put(form.setSubmitFailed(formName, ...action.payload.props.fields))

      if (action.payload.props.onSubmitFail) {
        action.payload.props.onSubmitFail(
          { _error: 'submit error' },
          action.payload.dispatch,
          err,
          action.payload.props,
        )
      }
    } catch (err) {
      console.error(err)
    }
  }
}

function* handleUpdateForm(action) {
  const formName = action.payload.props.form

  try {
    log(action)

    yield put(form.startSubmit(formName))

    const [_, [success, failure]] = yield all([
      put(actions.updateEntry(action.payload.data)),
      race([
        take('MODULE/PROJECT/UPDATE_ENTRY/SUCCESS'),
        take('MODULE/PROJECT/UPDATE_ENTRY/FAILURE'),
      ]),
    ])

    if (failure) {
      throw failure
    }

    yield put(form.stopSubmit(formName))
    yield put(form.setSubmitSucceeded(formName))

    if (action.payload.props.onSubmitSuccess) {
      action.payload.props.onSubmitSuccess(
        success?.payload?.registratedEntry,
        action.payload.dispatch,
        action.payload.props,
      )
    }
  } catch (err) {
    console.error(err)
    try {
      yield put(
        form.stopSubmit(formName, {
          _error: 'SubmitFailed',
        }),
      )

      yield put(form.setSubmitFailed(formName, ...action.payload.props.fields))

      if (action.payload.props.onSubmitFail) {
        action.payload.props.onSubmitFail(
          { _error: 'submit error' },
          action.payload.dispatch,
          err,
          action.payload.props,
        )
      }
    } catch (err) {
      console.error(err)
    }
  }
}

export function* sagas() {
  yield all([
    takeLatest('MODULE/PROJECT/INIT/REQUEST', handleInit),
    takeLatest('MODULE/PROJECT/LOAD_ENTRIES/REQUEST', handleLoadEntries),
    takeLatest('MODULE/PROJECT/LOAD_ENTRY/REQUEST', handleLoadEntry),
    takeLatest('MODULE/PROJECT/ADD_ENTRY/REQUEST', handleAddEntry),
    takeLatest('MODULE/PROJECT/UPDATE_ENTRY/REQUEST', handleUpdateEntry),
    takeLatest('MODULE/PROJECT/REMOVE_ENTRY/REQUEST', handleRemoveEntry),
    takeLatest('MODULE/PROJECT/CLONE_ENTRY/REQUEST', handleCloneEntry),
    takeLatest('MODULE/PROJECT/SET_ACTIVE', handleSetActive),
    // Form
    takeLatest('MODULE/PROJECT/CREATE_FORM/SUBMIT', handleCreateForm),
    takeLatest('MODULE/PROJECT/UPDATE_FORM/SUBMIT', handleUpdateForm),
  ])
}
